import type { ReactNode } from 'react';
import { Link, buildCountryPath } from '../router';
import { localName, type Country, type Lang } from '../lib/countries';

/**
 * A country link that always follows the active language's localized detail route.
 * Keeping this in one component avoids accidentally sending localized game pages
 * back to an English `/country/...` URL.
 */
export default function CountryLink({
  country,
  lang,
  className,
  children,
  title,
}: {
  country: Country;
  lang: Lang;
  className?: string;
  children?: ReactNode;
  title?: string;
}) {
  const name = localName(country, lang);
  return (
    <Link to={buildCountryPath(lang, country.cca3)} className={className} title={title ?? name}>
      {children ?? name}
    </Link>
  );
}
